import { CustomerAddressModelType } from '@teinor/erp/types/company/customer/customerAddress'
import { SetStateAction } from 'react'
import { OrderData } from '../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { parseAddressToOneLine } from '../../../../../../utils/globals/address'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'

type ProductsToProcessingTy = {
    units: number
    products: number[]
}
export interface SelectedTableForProcessingTy {
    canceling: ProductsToProcessingTy
    processing: ProductsToProcessingTy
    forSend: ProductsToProcessingTy
}
export const parseSelectedTableForProcessing = (completeData: OrderData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const isSelectedTableData = parsedData?.selectedTableData && parsedData?.selectedTableData?.length ? true : false
    const myTableData = parsedData?.selectedTableData?.length ? parsedData?.selectedTableData : parsedData?.tableData
    const result: SelectedTableForProcessingTy = {
        canceling: {
            units: 0,
            products: []
        },
        processing: {
            units: 0,
            products: []
        },
        forSend: {
            units: 0,
            products: []
        }
    }
    for (const element of myTableData) {
        let myElement = element
        if (isSelectedTableData && parsedData?.dictPosTableData?.[myElement.id] !== undefined) {
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            const quantity = parseFloat(myElement.quantity)
            if (quantity === 0 && !myElement.saveRest) {
                result.canceling.products.push(myElement.id)
                result.forSend.products.push(myElement.id)
                result.forSend.units = result.forSend.units + quantity
            } else {
                result.processing.products.push(myElement.id)
                result.processing.units = result.processing.units + quantity
                if (quantity > 0) {
                    result.forSend.products.push(myElement.id)
                    result.forSend.units = result.forSend.units + quantity
                }
            }   
        }
    }
    return result
}

export const parseSelectedTableWorkSheetForProcessingByType = (completeData: OrderData, type: string | null) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    let myProductsByType: number[] | null = []
    if (type !== 'allProducts') {
        if (type === 'selectedProducts') {
            if (parsedData?.selectedTableData?.length) {
                for (const element of parsedData?.selectedTableData) {
                    if (element.type !== 'productCombinedHeader'){
                        myProductsByType.push(element.id)
                    }
                }
            }
        } else {
            for (const element of parsedData?.tableData) {
                if (element.type !== 'productCombinedHeader'){
                    if (type === 'onlyAddons' && element.OrderProductId ) {
                        myProductsByType.push(element.id)
                    } else if (type === 'onlyMain' && !element.OrderProductId) {
                        myProductsByType.push(element.id)
                    }
                }
            }
        }
    }
    return myProductsByType
}
export const parseSelectedProductsForProcessing = (completeData: OrderData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const mySelectedTableData = parsedData?.selectedTableData?.length ? parsedData?.selectedTableData : parsedData?.tableData
    let myProductsIds: number[] | null = []
    for (const element of mySelectedTableData) {
        myProductsIds.push(element.id)
    }
    return myProductsIds
}

export const parseServicesFromDictShippingCompanies = (shippingServices: TwinDictionary) => {
    const preResult: any [] = []
    for (const key in shippingServices) {
        const shippingService = shippingServices[key]
        preResult.push({ order: shippingService.order, value: shippingService.ShippingServiceId, text: shippingService.ShippingService.ShippingCompany.name + ' - ' + shippingService.ShippingService.name  })
    }
    preResult.sort((a, b) => {
        return a.order > b.order ? 1 : -1
    })
    return preResult
}

export const parseDictCustomerAddress = (items: false | CustomerAddressModelType[], setDictCustomerAddress: React.Dispatch<SetStateAction<TwinDictionary>>) => {
    if (items && items.length) {
        let parsedJSON: TwinDictionary = {}
        for (const key in items) {
            const item = items[key]
            parsedJSON[item['id']] = { name: parseAddressToOneLine(item) }

        }
        setDictCustomerAddress(parsedJSON)
    }
}

export const displayFullNameService = (items: TwinDictionary | TwinDictionary[], value: string | number): string => {
    return items?.[parseInt(String(value))]?.ShippingService?.ShippingCompany?.name + ' - ' + items?.[parseInt(String(value))]?.ShippingService.name
}